import { INITIALIZE, UPDATE_FORM_STATE } from "../actions/FormAction";

const initialState = {     
    closeForm: null,   
    isDirty:false
}

const FormReducer = (state = initialState, action)=>{
    switch(action.type){
        case INITIALIZE:
            return {...state,  closeForm:action.closeForm}
        case UPDATE_FORM_STATE:
            return {...state, isDirty:action.isDirty}        
        default:
            return {...state}
    }
}

export default FormReducer;
